import { publicRoutes } from './constants';

// Copy, outcomes and timings shared with consumer web (ENG-2782) so the prompt behaves the same in every app.
export const EMAIL_VERIFICATION_CODE_LENGTH = 6;
export const DEFAULT_RESEND_SECONDS = 60;
export const INVALID_CODE_MESSAGE = 'Invalid code.';
export const EMAIL_VERIFIED_TOAST_TITLE = 'Email Verified';
export const SUPPORT_HOME_URL = 'https://support.universaltennis.com/en/support/home';

export const SendCodeTriggers = {
    INITIAL: 'initial',
    RESEND: 'resend',
};

export const SendCodeOutcomes = {
    SENT: 'sent',
    TOO_SOON: 'tooSoon',
    ALREADY_SENT: 'alreadySent',
    ALREADY_VERIFIED: 'alreadyVerified',
    DAILY_LIMIT: 'dailyLimit',
};

export const VerifyCodeOutcomes = {
    VERIFIED: 'verified',
    ALREADY_VERIFIED: 'alreadyVerified',
    INVALID: 'invalid',
    EXPIRED: 'expired',
    LOCKED: 'locked',
    DAILY_LIMIT: 'dailyLimit',
};

// `tooSoon` on the FIRST send is not an error: a code is already on its way, so the member goes
// straight to code entry with the countdown.
const CODE_ENTRY_SEND_OUTCOMES = new Set([
    SendCodeOutcomes.SENT,
    SendCodeOutcomes.TOO_SOON,
    SendCodeOutcomes.ALREADY_SENT,
    SendCodeOutcomes.DAILY_LIMIT,
]);

const VERIFIED_OUTCOMES = new Set([VerifyCodeOutcomes.VERIFIED, VerifyCodeOutcomes.ALREADY_VERIFIED]);

const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

// Leagues has no sign-in, callback or verify routes of its own (sign-in is a full-page trip through
// the legacy app), so only the public, member-less routes are excluded.
export const isEmailVerificationPromptExcludedPath = (pathname) => {
    return publicRoutes.includes(pathname);
};

export const isImpersonatedSession = (user) => {
    const originatingMemberId = user?.impersonationOriginatingMemberId;
    return !!originatingMemberId && originatingMemberId !== user?.id;
};

export const isEmailVerificationPromptFlagged = (user) => user?.emailVerificationPrompt === true;

export const getVerificationEmailAddress = (user) => user?.emailVerificationAddress ?? user?.email ?? '';

export const isCodeEntrySendOutcome = (outcome) => CODE_ENTRY_SEND_OUTCOMES.has(outcome);

export const isVerifiedOutcome = (outcome) => VERIFIED_OUTCOMES.has(outcome);

export const resendSecondsFrom = (response) => {
    const seconds = response?.retryAfterSeconds;

    if (typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0) {
        return Math.ceil(seconds);
    }

    return DEFAULT_RESEND_SECONDS;
};

// `alreadySent` with no wait left means the code in the inbox can be resent now: no countdown, where
// resendSecondsFrom alone would turn the 0 into a default 60 s wait.
export const countdownSecondsForSendOutcome = (outcome, response) => {
    const retryAfterSeconds = Number(response?.retryAfterSeconds) || 0;

    if (outcome === SendCodeOutcomes.ALREADY_SENT && retryAfterSeconds <= 0) {
        return 0;
    }

    return resendSecondsFrom(response);
};

export const formatCountdown = (totalSeconds) => {
    const safe = Math.max(0, Math.floor(totalSeconds || 0));
    const hours = Math.floor(safe / SECONDS_PER_HOUR);
    const minutes = Math.floor((safe % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    const seconds = String(safe % SECONDS_PER_MINUTE).padStart(2, '0');

    if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, '0')}:${seconds}`;
    }

    return `${minutes}:${seconds}`;
};
